var REQUIRED_FIELD_METHODS = ['_getValue', '_setValue', '_validate'];export default REQUIRED_FIELD_METHODS;